import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-509adb45"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 p-5" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spinner fa-spin fa-fw fa-2x" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: _ctx.ready ? 'Register' : 'Please wait',
    onConfirm: _cache[0] || (_cache[0] = ($event: any) => (_ctx.purchase())),
    "cancel-button": false,
    "min-width": "800px",
    "max-width": "800px"
  }, {
    default: _withCtx(() => [
      (_ctx.ready)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
    ]),
    _: 1
  }, 8, ["title"]))
}